module.exports = __webpack_public_path__ + "static/media/notifNovoChamado.323db587.svg";